import { Injectable } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FemaleFertilityCheckinQuestionnaireForm } from "../../interfaces/pathways-form/female-fertility-checkin.interface";
import { FemaleSocialFreezingQuestionnaireForm } from "../../interfaces/pathways-form/female-social-freezing.interface";
import { MaleFertilityCheckinQuestionnaireForm } from "../../interfaces/pathways-form/male-fertility-checkin.interface";
import { MaleSocialFreezingQuestionnaireForm } from "../../interfaces/pathways-form/male-social-freezing.interface";
import { PmaQuestionnaireForm } from "../../interfaces/pathways-form/pma.interface";

@Injectable({
  providedIn: "root",
})
export class MatchingPathwaysManagerService {
  /** */
  private readonly _pmaForm: FormGroup<PmaQuestionnaireForm> =
    new FormGroup<PmaQuestionnaireForm>({
      ageRange: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      partnerAgeRange: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityTests: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      previousTreatments: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityTreatments: new FormControl<string[]>([], {
        nonNullable: true,
        validators: [Validators.required],
      }),
      infertilityCause: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      consultationReason: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      emotionalState: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      pregnancyHistory: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      // pastPregnancies: new FormControl<string>("", {
      //   nonNullable: true,
      //   validators: [Validators.required],
      // }),
      residenceRegion: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      informedConsent: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      })
    });

  /** */
  private readonly _maleSocialFreezingForm: FormGroup<MaleSocialFreezingQuestionnaireForm> =
    new FormGroup<MaleSocialFreezingQuestionnaireForm>({
      ageRange: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityGoal: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilitySpecialist: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      semenAnalysis: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      semenAnalysisTiming: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityDiagnoses: new FormControl<string[]>([], {
        nonNullable: true,
        validators: [Validators.required],
      }),
      semenFreezingReason: new FormControl<string[]>([], {
        nonNullable: true,
        validators: [Validators.required],
      }),
      emotionalState: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      residenceRegion: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      informedConsent: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      })
    });

  /** */
  private readonly _femaleSocialFreezingForm: FormGroup<FemaleSocialFreezingQuestionnaireForm> =
    new FormGroup<FemaleSocialFreezingQuestionnaireForm>({
      ageRange: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityGoal: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilitySpecialist: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityTests: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityTestsTiming: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityDiagnoses: new FormControl<string[]>([], {
        nonNullable: true,
        validators: [Validators.required],
      }),
      pastPregnancies: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityExpectations: new FormControl<string[]>([], {
        nonNullable: true,
        validators: [Validators.required],
      }),
      emotionalState: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      residenceRegion: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      informedConsent: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      })
    });

  /** */
  private readonly _femaleFertilityCheckinForm: FormGroup<FemaleFertilityCheckinQuestionnaireForm> =
    new FormGroup<FemaleFertilityCheckinQuestionnaireForm>({
      ageRange: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityGoal: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilitySpecialist: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityDiagnoses: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityDiagnosesTime: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      pathologiesDiagnoses: new FormControl<string[]>([], {
        nonNullable: true,
        validators: [Validators.required],
      }),
      pastPregnancies: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityExpectations: new FormControl<string[]>([], {
        nonNullable: true,
        validators: [Validators.required],
      }),
      emotionalAspect: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      residenceRegion: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      informedConsent: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
    });

  /** */
  private readonly _maleFertilityCheckinForm: FormGroup<MaleFertilityCheckinQuestionnaireForm> =
    new FormGroup<MaleFertilityCheckinQuestionnaireForm>({
      ageRange: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityGoal: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilitySpecialist: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      spermiogramDone: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      spermiogramTime: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      pathologiesDiagnoses: new FormControl<string[]>([], {
        nonNullable: true,
        validators: [Validators.required],
      }),
      fertilityExpectations: new FormControl<string[]>([], {
        nonNullable: true,
        validators: [Validators.required],
      }),
      emotionalAspect: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      residenceRegion: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
      informedConsent: new FormControl<string>("", {
        nonNullable: true,
        validators: [Validators.required],
      }),
    });

  /** */
  // private readonly _pregnancyJourneyForm: FormGroup<PregnancyJourneyQuestionnaireForm> =
  //   new FormGroup<PregnancyJourneyQuestionnaireForm>({
  //     pregnancyHistory: new FormControl<string>("", {
  //       nonNullable: true,
  //       validators: [Validators.required],
  //     }),
  //     currentPregnancyWeek: new FormControl<string>("", {
  //       nonNullable: true,
  //       validators: [Validators.required],
  //     }),
  //     firstUltrasoundDone: new FormControl<string>("", {
  //       nonNullable: true,
  //       validators: [Validators.required],
  //     }),
  //     interestedServices: new FormControl<string[]>([], {
  //       nonNullable: true,
  //       validators: [Validators.required],
  //     }),
  //     hasParticipatedBefore: new FormControl<string>("", {
  //       nonNullable: true,
  //     }),
  //     emotionalState: new FormControl<string>("", {
  //       nonNullable: true,
  //       validators: [Validators.required],
  //     }),
  //     additionalSupportProfessionals: new FormControl<string[]>([], {
  //       nonNullable: true,
  //     }),
  //     treatmentUrgency: new FormControl<string>("", {
  //       nonNullable: true,
  //       validators: [Validators.required],
  //     }),
  //   });

  /**
   *
   * @param pathway
   * @returns
   */
  public getPathwayForm(pathway: string): FormGroup {
    if (pathway === "" || !pathway) {
      return new FormGroup({});
    }

    switch (pathway) {
      case "PMA":
        return this._pmaForm;
      case "Social freezing uomo":
        return this._maleSocialFreezingForm;
      case "Social freezing donna":
        return this._femaleSocialFreezingForm;
      case "Fertility check-in donna":
        return this._femaleFertilityCheckinForm;
      case "Fertility check-in uomo":
        return this._maleFertilityCheckinForm;
      case "Benessere Fertile (Donna)":
        return this._femaleFertilityCheckinForm;
      case "Benessere Fertile (Uomo)":
        return this._maleFertilityCheckinForm;
      // case "Maternità e gravidanza":
      //   return this._pregnancyJourneyForm;
      default:
        return this._pmaForm;
    }
  }
}
